import { ReactNode } from "react";

import { Layout } from "antd";

import {
    ApplicationBarVariant,
    ApplicationBarVariantContext,
} from "../ApplicationBar/ApplicationBarVariant";

import * as theme from "./PageMain.css";

export interface PageMainProps {
    /**
     * The `ApplicationBarToolbar`, if the page has one.
     */
    toolbar?: ReactNode;
    /**
     * `flat` makes the toolbar white, as inside a flat `ApplicationBarHeader`.
     * The `ApplicationBarToolbar` takes the same variant. Defaults to `default`.
     */
    variant?: ApplicationBarVariant;
    /**
     * The `PageContent`.
     */
    children: ReactNode;
}

/**
 * The column beside a page navigation menu in `PageColumns`.
 */
export function PageMain({
    toolbar,
    variant = "default",
    children,
}: PageMainProps) {
    return (
        <Layout className={theme.main}>
            {toolbar && (
                <div className={theme.toolbar[variant]}>
                    <ApplicationBarVariantContext.Provider value={variant}>
                        {toolbar}
                    </ApplicationBarVariantContext.Provider>
                </div>
            )}
            {children}
        </Layout>
    );
}
